

import styled from "styled-components"
import {MdKeyboardArrowDown} from "react-icons/md"
import { useState } from "react";
import moment from "moment"

const Container = styled.div`
    font-weight: var(--font-weight-sm);
    font-size: var(--font-size-sm);
    color: ${({theme}) => theme.mainTextColor};

  h4{
    font-weight: var(--font-weight-lg);
    font-size: var(--font-size-sm);
  }


.rota{
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 10px 0 10px 30px;
  width: 70%;
  gap: 15px;

  .rota-item{
    display: flex;
    flex-direction: column;

    .rota-item-top{
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item-content{
            display: flex;
            align-items: center;
            margin-bottom: 5px;

            .rota-item-name{
                font-weight: var(--font-weight-lg);
                font-size: var(--font-size-sm);
                color: ${({theme}) => theme.mainTextColor};
                padding-right: 2px;
            }

            .date{
                font-weight: var(--font-weight-sm);
                font-size: var(--font-size-sm);
                margin-right: 10px;
            }

            .time{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
            }
        }

        .detay-btn{
            margin-left: 20px;
            display: flex;
            align-items: center;
            font-weight: var(--font-weight-sm);
            font-size: 12px;
        }
    }

    .location{
      font-weight: var(--font-weight-sm);
      font-size: var(--font-size-sm);
    }

    .sevk-bicimleri{
        display: flex;
        flex-wrap: wrap;
        font-weight: var(--font-weight-sm);
      font-size: var(--font-size-sm);
    }
  }
}

.total-km{
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-lg);
  color: ${({theme}) => theme.mainTextColor};
}


  .seperator{
    width: 100%;
    height: 1px;
    background-color: ${({theme}) => theme.contrastBorderColor};
  }
`

const RouteDetails = ({route, routeDistance}) => {

  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() +1)

  const [activeItem, setActiveItem] = useState(null)

  return (
    <Container>
        <h4 className="title">Rota</h4>
        <div className="rota">
          {
            route?.map((item,i) => {
              const date = new Date(item.date)
              return (
                  <div className="rota-item">
                    <div className="rota-item-top">
                        <div className="item-content">
                            <span className="rota-item-name">{item?.locationType === "yukleme" ? "Yükleme": "Boşaltma"}: </span>
                            {
                                date &&
                                <span className="date">{date.toDateString() === today.toDateString() ? "Bugün" : date.toDateString() === (tomorrow.toDateString())  ? "Yarın": item?.date && moment(item?.date).format('DD.MM.YYYY') }</span>
                            }
                            {
                                (item?.saatBaslangic || item?.saatBitis) &&
                                <span className="time">{item?.saatBaslangic}-{item?.saatBitis}</span>
                            }
                        </div>
                        {
                            //! yukleme mi bosaltma mı olduğunun önemi yok sadece Key i önemli
                          (item?.adres || item?.adresTarif || item?.sevkBicimleri?.filter(sevkBicimi => sevkBicimi?.status)?.length > 0) &&
                          <button className="detay-btn" onClick={() => setActiveItem(activeItem === item.id ? null : item.id)}>Detay <MdKeyboardArrowDown/></button>
                        }
                    </div>
                    {
                        (item?.locationData?.il || item?.locationData?.ilce) &&
                        <div className="location">{`${item?.locationData?.location}`}</div>
                    }
                    {
                        activeItem === item.id && 
                        <>
                            <div>{item?.adres}</div>
                            {/* //! yukleme mi bosaltma mı olduğunun önemi yok sadece Key i önemli */}
                            <div className="sevk-bicimleri">{item?.sevkBicimleri?.filter(sevkBicimi => sevkBicimi?.status).map((item) => <span>{item.name + ","}</span>)}</div>
                        </>
                    }
                  </div>
                )
              })
          }
          <div className="total-km">{routeDistance && `Toplam Km: ${routeDistance > 0 ? routeDistance : ""}`}</div>
        </div>
        <div className="seperator"/>
    </Container>
  )
}

export default RouteDetails